import { Component, OnInit } from '@angular/core';
import { EMRService } from 'app/EMR/EMR.service';
import { MatDialog } from '@angular/material/dialog';
import { HelpListPopupComponent } from 'app/EMR/Doctor/doctor-other-info/help-list-popup/help-list-popup.component';
import { AuthService } from 'app/auth/auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DashboardService } from 'app/dashboard/dashboard.service';
@Component({
  selector: 'app-other_info_PE',
  templateUrl: './other_info_PE.component.html',
  styleUrls: ['./other_info_PE.component.scss']
})
export class Other_info_PEComponent implements OnInit {
  private Optypedata: Object;
  private data: any;
  destroyinfoPE$: Subject<boolean> = new Subject<boolean>();
  constructor(private emrservice: EMRService, private authService: AuthService,
    private dashboardService: DashboardService,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.emrservice.enabledisableopt=true;
    this.getPostopType();
  
  } 
  getdata(param){
if(param != null){
  this.data = this.authService.users.filter(item => item.pkUserId == param);
if(this.data.length >0){
  return this.data[0].userName;
}else{
  return null;
}
}

  }
 
  refReasonPOpup(type) {
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        typeid: type
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroyinfoPE$)).subscribe(result => {
      if (result != 0) {
        this.emrservice.enabledisableopt =false;
        this.emrservice.opto.studentName=result;

      }
    });
  }
  getPostopType(){
    this.emrservice.getOpType().pipe(takeUntil(this.destroyinfoPE$)).subscribe(data =>{  
  
      this.Optypedata = data;
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  public PostOpChange(event){  
    this.emrservice.enabledisableopt =false;
     this.emrservice.opto.isPostop = event.checked;    
}
selectChange(event){
  this.emrservice.enabledisableopt =false;
}
checkChange($event){
  this.emrservice.enabledisableopt =false;
}
ngOnDestroy():void {
  this.destroyinfoPE$.next(true);
  this.destroyinfoPE$.unsubscribe();
  this.Optypedata=null;
  this.data=null;
}
}
